namespace Serenity.EmailClient {

    export function mailboxFolderSelectPadding(folder: EmailFolder) {
        var spc = "";
        for (var i = 0; i < folder.FullName.split('.').length - 1; i++)
            spc += "\xa0\xa0\xa0\xa0";
        return spc;
    }

    export interface MailboxToolbarProps {
        onCheckAll: () => void;
        onToggleSeen: () => void;
        allChecked: boolean;
        onDelete: () => void;
        onRefresh: () => void;
        onMoveToFolder: (folder: string) => void;
        folder: string;
        flatFolderList: EmailFolder[];
        page: number;
        pageSize: number;
        messageCount: number;
        onChangePage: (page: number) => void;
    }

    export class MailboxToolbar extends React.Component<MailboxToolbarProps, {}> {

        handleMoveToFolder(e: React.ChangeEvent<HTMLSelectElement>) {
            e.target.value && this.props.onMoveToFolder(e.target.value);
            e.target.value = "";
        }

        render() {
            return (
                <div className="mailbox-controls">
                    <button type="button" className="btn btn-default btn-sm checkbox-toggle"
                        onClick={e => this.props.onCheckAll()}>
                        <i className={this.props.allChecked ? 'fa fa-check-square-o' : 'fa fa-square-o'}></i>
                    </button>{' '}
                    <div className="btn-group">
                        <button type="button" className="btn btn-default btn-sm" onClick={e => this.props.onToggleSeen()}
                            title={Q.text("Site.EmailClient.ToggleReadButton")}>
                            <i className="fa fa-star-o"></i>
                        </button>
                        <button type="button" className="btn btn-default btn-sm" onClick={e => this.props.onDelete()}
                            title={Q.text("Site.EmailClient.DeleteButton")}>
                            <i className="fa fa-trash-o"></i>
                        </button>
                        <button type="button" className="btn btn-default btn-sm" onClick={e => this.props.onRefresh()}
                            title={Q.text("Site.EmailClient.RefreshButton")}>
                            <i className="fa fa-refresh"></i>
                        </button>{' '}
                        <select style={{ padding: "4px", margin: "0 4px" }} onChange={e => this.handleMoveToFolder(e)}>
                            <option value="">{Q.text("Site.EmailClient.MoveToFolder")}</option>
                            {this.props.flatFolderList.filter(x => x.FullName != this.props.folder).map(x =>
                                <option key={x.FullName} value={x.FullName}>
                                    {mailboxFolderSelectPadding(x) + mailboxFolderName(x)}
                                </option>)}
                        </select>
                    </div>
                    <div className="pull-right">
                        <span>{this.props.page * this.props.pageSize + 1}</span>
                        -
                        <span>{Math.min(this.props.page * this.props.pageSize + this.props.pageSize, this.props.messageCount)}</span>
                        <span> / </span>
                        <span>{this.props.messageCount}</span>{' '}
                        <div className="btn-group">
                            <button type="button" className="btn btn-default btn-sm"
                                onClick={e => this.props.onChangePage(this.props.page - 1)}>
                                <i className="fa fa-chevron-left"></i>
                            </button>
                            <button type="button" className="btn btn-default btn-sm"
                                onClick={e => this.props.onChangePage(this.props.page + 1)}>
                                <i className="fa fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            );
        }
    }
}